<template>
  <main
    class="mt-3"
    v-if="currentErrand.features.showInformation && currentErrand"
  >
    <div class="grid">
      <div class="grid-item">
        <PolygonIsland
          :header="$t('contact.information')"
          v-for="workSiteContact in currentErrand.worksite_contacts"
          :key="workSiteContact.email_address"
        >
          <dl class="info-list">
            <dt class="info-list__key">
              {{ $t('contact.persons') }}
            </dt>

            <dd class="info-list__value">
              {{ workSiteContact.last_name || '-' }}
            </dd>

            <dt class="info-list__key">
              {{ $t('contact.phone') }}
            </dt>

            <dd class="info-list__value">
              {{ formatPhoneNumber(workSiteContact.phone) || '-' }}
            </dd>

            <dt class="info-list__key">
              {{ $t('contact.email') }}
            </dt>

            <dd class="info-list__value">
              {{ workSiteContact.email_address || '-' }}
            </dd>
          </dl>
        </PolygonIsland>
      </div>
      <div class="grid-item">
        <PolygonIsland :header="$t('contact.addressInfo')">
          <dl class="info-list">
            <dt class="info-list__key">
              {{ $t('contact.address') }}
            </dt>

            <dd class="info-list__value">
              {{ getValueOrDefault('address') }}
            </dd>

            <dt class="info-list__key">
              {{ $t('contact.place') }}
            </dt>

            <dd class="info-list__value">
              {{ getValueOrDefault('city') }}
            </dd>

            <dt class="info-list__key">
              {{ $t('contact.zip') }}
            </dt>

            <dd class="info-list__value">
              {{ getValueOrDefault('zip_code') }}
            </dd>
          </dl>
        </PolygonIsland>
      </div>
      <div class="grid-item">
        <PolygonIsland :header="$t('contact.errandInfo')">
          <dl class="info-list">
            <dt class="info-list__key">
              {{ $t('contact.errandNo') }}
            </dt>

            <dd class="info-list__value">
              {{ getValueOrDefault('claim_no') }}
            </dd>

            <dt class="info-list__key">
              {{ $t('contact.policyNumber') }}
            </dt>

            <dd class="info-list__value">
              {{ getValueOrDefault('policy_no') }}
            </dd>

            <dt class="info-list__key">
              {{ $t('contact.dateOfDamage') }}
            </dt>

            <dd class="info-list__value">
              {{ formatDate(currentErrand.damage_date, 'll') || '-' }}
            </dd>

            <dt class="info-list__key">
              {{ $t('contact.insuranceCompany') }}
            </dt>

            <dd class="info-list__value">
              {{ getValueOrDefault('sparkInsurer.text') }}
            </dd>
          </dl>
        </PolygonIsland>
      </div>
      <div class="grid-item">
        <PolygonIsland :header="$t('contact.notes')">
          <dl class="info-list">
            <dt class="info-list__key">
              {{ $t('contact.orderNote') }}
            </dt>

            <dd
              class="info-list__value"
              v-html="nl2br(getValueOrDefault('concatenatedNotes.sparkordernote'))"
            >
            </dd>

            <dt class="info-list__key">
              {{ $t('contact.workInstruction') }}
            </dt>

            <dd
              class="info-list__value"
              v-html="nl2br(getValueOrDefault('concatenatedNotes.sparkworkinstr'))"
            >
            </dd>
          </dl>
        </PolygonIsland>
      </div>

    </div>
    <!-- STARTING -->
    <!-- <div class="main__left">

    </div>

    <div class="main__right">

    </div> -->
  </main>
</template>

<script>
import utils from '@/core/utils'

export default {
  methods: {
    nl2br: utils.nl2br,
    getValueOrDefault(path) {
      return this.get(this.currentErrand, path) || '-'
    }
  }
}
</script>

<style lang="scss">
.info-list {
  margin: 0;
}

.info-list__key {
  @include font-size(s);
  display: block;
  line-height: 1.8;
  color: color(medium);
}

.info-list__value {
  margin-left: 0;
  &:not(:last-child) {
    margin-bottom: measure(xxs);
    padding-bottom: measure(xxs);
    border-bottom: solid 1px color(light);
  }
}
.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: measure(s);
  @media #{$mq-mobile-only} {
    grid-template-columns: 1fr;
  }
}
</style>
